module.exports = __webpack_public_path__ + "img/jt-whatsapp.81904790.webp";